export default "__VITE_ASSET__BWkG6plA__"